import type {ComponentPropsWithoutRef, ReactNode} from 'react'

import {useSiteHref} from '@/utils/siteHref'

type SiteLinkProps = Omit<ComponentPropsWithoutRef<'a'>, 'href'> & {
  /** The site the link goes to (utils/domains.js `allSites`). */
  site: string
  /** The root-relative path there, with any query and hash. */
  path: string
  children: ReactNode
}

/**
 * A link to another site (utils/siteHref.ts) as a plain `<a>`: never
 * next/link. A cross-site link changes the site (on a switching host it is the
 * same-origin path with `?site=`, which the middleware turns into the session
 * cookie and a redirect; on production another host), so it is a document
 * navigation, with no prefetch of the other site's `_next/data` from this one.
 * For a Helios link primitive pass its `clientNavigation={false}` instead.
 */
export default function SiteLink({
  site,
  path,
  children,
  ...anchor
}: SiteLinkProps) {
  return (
    <a {...anchor} href={useSiteHref(site, path)}>
      {children}
    </a>
  )
}
